
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ContractFormValues } from "../ContractFormSchema";

interface PaymentTypeSectionProps {
  form: UseFormReturn<ContractFormValues>;
}

export function PaymentTypeSection({ form }: PaymentTypeSectionProps) {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name="paymentType"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t("Payment Type")}</FormLabel>
          <Select
            onValueChange={field.onChange}
            value={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={t("Select payment type")} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="BankTransfer">{t("Invoice")}</SelectItem>
              <SelectItem value="Cash">{t("Cash")}</SelectItem>
              <SelectItem value="Cards">{t("Card")}</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
